import { UEFA_SEASON_ID } from '../../../store'

export const uefaSeries: {
  [key: string]: Array<{
    label: string
    value: string
    tags: Array<{
      tag: string
      date: Date
    }>
  }>
} = {
  [Object.keys(UEFA_SEASON_ID)[1]]: [
    { label: 'Play-Off', value: 'play-off', tags: [
      { tag: 'bajnokok-ligaja-play-off-2025-26', date: new Date('2025-08-12') }
    ] },
    { label: '1. forduló', value: '1-fordulo', tags: [
      { tag: 'bajnokok-ligaja-1-fordulo-2025-26', date: new Date('2025-09-16') }
    ] },
    { label: '2. forduló', value: '2-fordulo', tags: [
      { tag: 'bajnokok-ligaja-2-fordulo-2025-26', date: new Date('2025-09-30') }
    ] },
    { label: '3. forduló', value: '3-fordulo', tags: [
      { tag: 'bajnokok-ligaja-3-fordulo-2025-26', date: new Date('2025-10-21') }
    ] },
    { label: '4. forduló', value: '4-fordulo', tags: [
      { tag: 'bajnokok-ligaja-4-fordulo-2025-26', date: new Date('2025-11-04') }
    ] },
    { label: '5. forduló', value: '5-fordulo', tags: [
      { tag: 'bajnokok-ligaja-5-fordulo-2025-26', date: new Date('2025-11-25') }
    ] },
    { label: '6. forduló', value: '6-fordulo', tags: [
      { tag: 'bajnokok-ligaja-6-fordulo-2025-26', date: new Date('2025-12-09') }
    ] },
    { label: '7. forduló', value: '7-fordulo', tags: [
      { tag: 'bajnokok-ligaja-7-fordulo-2025-26', date: new Date('2026-01-20') }
    ] },
    { label: '8. forduló', value: '8-fordulo', tags: [
      { tag: 'bajnokok-ligaja-8-fordulo-2025-26', date: new Date('2026-01-28') }
    ] },
    { label: 'Rájátszás', value: 'rajatszas', tags: [
      { tag: 'bajnokok-ligaja-rajatszas-odavago-2025-26', date: new Date('2026-02-17') },
      { tag: 'bajnokok-ligaja-rajatszas-visszavago-2025-26', date: new Date('2026-02-24') }
    ] },
    { label: 'Nyolcaddöntő', value: 'nyolcaddonto', tags: [
      { tag: 'bajnokok-ligaja-nyolcaddonto-odavago-2025-26', date: new Date('2026-03-10') },
      { tag: 'bajnokok-ligaja-nyolcaddonto-visszavago-2025-26', date: new Date('2026-03-17') }
    ] },
    { label: 'Negyeddöntő', value: 'negyeddonto', tags: [
      { tag: 'bajnokok-ligaja-negyeddonto-odavago-2025-26', date: new Date('2026-04-07') },
      { tag: 'bajnokok-ligaja-negyeddonto-visszavago-2025-26', date: new Date('2026-04-14') }
    ] },
    { label: 'Elődöntő', value: 'elodonto', tags: [
      { tag: 'bajnokok-ligaja-elodonto-odavago-2025-26', date: new Date('2026-04-28') },
      { tag: 'bajnokok-ligaja-elodonto-visszavago-2025-26', date: new Date('2026-05-05') }
    ] },
    { label: 'Döntő', value: 'donto', tags: [
      { tag: 'bajnokok-ligaja-donto-2025-26', date: new Date('2026-05-30') }
    ] }
  ],
  [Object.keys(UEFA_SEASON_ID)[0]]: [
    { label: 'Play-Off', value: 'play-off', tags: [
      { tag: 'bajnokok-ligaja-play-off-2026-27', date: new Date('2026-08-18') }
    ] },
    { label: '1. forduló', value: '1-fordulo', tags: [
      { tag: 'bajnokok-ligaja-1-fordulo-2026-27', date: new Date('2026-09-08') }
    ] },
    { label: '2. forduló', value: '2-fordulo', tags: [
      { tag: 'bajnokok-ligaja-2-fordulo-2026-27', date: new Date('2026-10-13') }
    ] },
    { label: '3. forduló', value: '3-fordulo', tags: [
      { tag: 'bajnokok-ligaja-3-fordulo-2026-27', date: new Date('2026-10-20') }
    ] },
    { label: '4. forduló', value: '4-fordulo', tags: [
      { tag: 'bajnokok-ligaja-4-fordulo-2026-27', date: new Date('2026-11-03') }
    ] },
    { label: '5. forduló', value: '5-fordulo', tags: [
      { tag: 'bajnokok-ligaja-5-fordulo-2026-27', date: new Date('2026-11-24') }
    ] },
    { label: '6. forduló', value: '6-fordulo', tags: [
      { tag: 'bajnokok-ligaja-6-fordulo-2026-27', date: new Date('2026-12-08') }
    ] },
    { label: '7. forduló', value: '7-fordulo', tags: [
      { tag: 'bajnokok-ligaja-7-fordulo-2026-27', date: new Date('2027-01-19') }
    ] },
    { label: '8. forduló', value: '8-fordulo', tags: [
      { tag: 'bajnokok-ligaja-8-fordulo-2026-27', date: new Date('2027-01-27') }
    ] },
    { label: 'Rájátszás', value: 'rajatszas', tags: [
      { tag: 'bajnokok-ligaja-rajatszas-odavago-2026-27', date: new Date('2027-02-16') },
      { tag: 'bajnokok-ligaja-rajatszas-visszavago-2026-27', date: new Date('2027-02-23') }
    ] },
    { label: 'Nyolcaddöntő', value: 'nyolcaddonto', tags: [
      { tag: 'bajnokok-ligaja-nyolcaddonto-odavago-2026-27', date: new Date('2027-03-09') },
      { tag: 'bajnokok-ligaja-nyolcaddonto-visszavago-2026-27', date: new Date('2027-03-16') }
    ] },
    { label: 'Negyeddöntő', value: 'negyeddonto', tags: [
      { tag: 'bajnokok-ligaja-negyeddonto-odavago-2026-27', date: new Date('2027-04-06') },
      { tag: 'bajnokok-ligaja-negyeddonto-visszavago-2026-27', date: new Date('2027-04-13') }
    ] },
    { label: 'Elődöntő', value: 'elodonto', tags: [
      { tag: 'bajnokok-ligaja-elodonto-odavago-2026-27', date: new Date('2027-04-27') },
      { tag: 'bajnokok-ligaja-elodonto-visszavago-2026-27', date: new Date('2027-05-04') }
    ] },
    { label: 'Döntő', value: 'donto', tags: [
      { tag: 'bajnokok-ligaja-donto-2026-27', date: new Date('2027-05-07') }
    ] }
  ]
}
